/**
 * @generated SignedSource<<90626692270b80ad2c1a5c3b758c8611>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveArticleArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleImageGalleryContent" | "contentLiveArticleArticle" | "globalCheckerContent" | "newsletterWidgetLiveArticleArticle" | "reduceWhitespaceByAvailableSpaceArticle">;
  readonly " $fragmentType": "liveArticleArticle";
};
export type liveArticleArticle$key = {
  readonly " $data"?: liveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newsletterWidgetLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "reduceWhitespaceByAvailableSpaceArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "db1e3ef100b0b852c664f96315d3e73a";

export default node;
